import { createTheme } from '@mui/material/styles';

// Vereinsfarben Schwarz/Gelb (Sp.Vgg. Lagerlechfeld-Graben), bewusst dezent eingesetzt:
// Schwarz trägt die Fläche (Kopfzeile, Buttons), das Gelb erscheint nur als feiner Akzent
// (Trennlinie, ausgewählter Menüpunkt) statt als große, grelle Fläche.
// Corporate-Design-Angleichung (2026-08-21): CLUB_YELLOW neu per Canvas-Histogramm aus
// club-logo.png ermittelt (RGB 255/216/0) und mit beverage-trackers gleichnamigem Token
// abgeglichen -- beide Repos hatten zuvor unabhängig einen leicht abweichenden Gelbton
// eingeschätzt (255/211/0 hier, 255/213/0 dort).
const CLUB_BLACK = '#1a1a1a';
const CLUB_YELLOW = '#ffd800';
// Corporate-Design-Angleichung (2026-08-23): Seitenhintergrund von beverage-trackers `--bt-bg`
// übernommen (styles.css) -- vorher ein leicht bläuliches Grau (#f4f6f8), jetzt derselbe warme
// Ton wie im Schwesterprojekt.
const PAGE_BACKGROUND = '#f7f6f1';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: CLUB_BLACK, contrastText: '#ffffff' },
    secondary: { main: CLUB_YELLOW, contrastText: '#1a1a1a' },
    background: { default: PAGE_BACKGROUND },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  components: {
    MuiAppBar: {
      defaultProps: { color: 'primary', elevation: 0 },
      styleOverrides: {
        root: { borderBottom: `3px solid ${CLUB_YELLOW}` },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { border: '1px solid #e0e0e0' },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderLeft: '3px solid transparent',
          '&.Mui-selected': {
            borderLeft: `3px solid ${CLUB_YELLOW}`,
            backgroundColor: 'rgba(255, 211, 0, 0.14)',
          },
          '&.Mui-selected:hover': {
            backgroundColor: 'rgba(255, 211, 0, 0.22)',
          },
        },
      },
    },
  },
});
